import * as React from 'react';
import { renderText } from '../bereiche/dateneingabe/assistent/assistent_helpers';
import { SimpleDialog } from '../core/dialog/SimpleDialog';
import style from './MainSelection.less';
import assisStyle from '../bereiche/dateneingabe/assistent/Assistent.less';

interface MainSelectionProps extends React.ClassAttributes<any> {
    modulSelected: string;
    data: any;
    onModulSelection: (modul: string) => void;
}

interface MainSelectionState extends React.ClassAttributes<any> {
    scale: number;
    moduleMouseOver?: string;
    mousePosX?: number;
    mousePosY?: number;
}

export class MainSelection extends React.Component<MainSelectionProps, MainSelectionState> {

    constructor(props: any) {
        super(props);
        this.state = {
            scale: 1
        };
        // this.infoRef = React.createRef();
        this.baumRef = React.createRef();
        this.resizeBaum = this.resizeBaum.bind(this);
    }

    // private infoRef: any;
    private infoWidth = '35%';
    private baumRef: any;
    private baumDefWidth = 1920;  // Orignalgröße
    private baumDefHeight = 1365; // Orignalgröße

    componentDidMount(): void {
        this.init();
    }

    init() {
        window.addEventListener('resize', this.resizeBaum);
        this.resizeBaum();
    }

    resizeBaum(): void {
        if (this.baumRef && this.baumRef.current) {
            const scaleW = (window.document.body.clientWidth - this.baumRef.current.offsetLeft - 40) / this.baumDefWidth;
            const scaleH = (window.document.body.clientHeight - 250) / this.baumDefHeight;
            const scale = Math.min(scaleW, scaleH);
            // console.log(scaleW, scaleH);
            this.setState({ scale, moduleMouseOver: null });
        }
    }

    render(): JSX.Element {
        const { scale } = this.state;
        const modul: string = (this.props.data || {}).MODUL_SELECTED;
        const img_baum: any = require('../img/baum_hq.png');
        const img_blatt: any = (modul && modul !== 'selection')
            ? require(`../img/baum_hq_${modul}.png`)
            : require('../img/baum_hq_none.png');
        return (
            <div
                className={assisStyle.entityForm}
                style={{ maxWidth: 'unset', margin: 'unset' }}
            >
                <div style={{ display: 'flex', flexDirection: 'row', height: '100%', overflow: 'hidden', alignItems: 'center' }}>
                    <div
                        // ref={this.infoRef}
                        style={{
                            minWidth: this.infoWidth, maxWidth: this.infoWidth, borderRight: '1px solid #ccc',
                            padding: '0 20px', marginRight: 20, textAlign: 'justify', hyphens: 'auto', fontSize: 16
                        }}
                    >
                        {renderText('Modulauswahl', this.props.data)}
                    </div>
                    <div
                        ref={this.baumRef}
                        style={{ transform: `scale(${scale})`, transformOrigin: 'left' }}
                    >
                        {this.renderBlatt(37, 34, 'classic', <span>Energie<br />„E-Tool classic“</span>)}
                        {this.renderBlatt(73, 55, 'cfm', <span>CO₂-Fußab-<br />druck (CFM)</span>)}
                        {this.renderBlatt(16, 63, 'nachhaltigkeit', <span>Nachhal<br />-tigkeit</span>)}
                        {this.renderBlatt(49, 70, 'steuer', <span>Strom - &<br />Energiesteuer</span>)}
                        <div
                            style={{
                                width: this.baumDefWidth, height: this.baumDefHeight, backgroundImage: `url(${img_baum})`,
                                backgroundSize: 'contain', display: 'inline-flex', filter: 'brightness(0.9)'
                            }}
                        >
                            <img
                                src={img_blatt}
                                width={this.baumDefWidth}
                                height={this.baumDefHeight}
                                style={{ filter: 'brightness(1.2) drop-shadow(#aaa 10px 10px 4px)' }}
                                alt=''
                            />
                        </div>
                    </div>
                </div>
                {this.state.moduleMouseOver && this.renderModulInfo()}
            </div >
        );
    }

    renderBlatt(right: number, top: number, modulKey: string, content: JSX.Element): JSX.Element {
        // const modulSelected = this.props.data.MODUL_SELECTED;
        // const styleSelected: React.CSSProperties = { textShadow: '0 0 10px white, 0 0 10px white' };
        return (
            <div
                onClick={() => this.props.onModulSelection(modulKey)}
                // onMouseMove={(event: any) => console.log(event.pageX, event.clientX)}
                onMouseOver={(event: any) => {
                    const mousePosX = event.target.getBoundingClientRect().left;
                    const mousePosY = event.target.getBoundingClientRect().top;
                    this.setState({ moduleMouseOver: modulKey, mousePosX, mousePosY });
                }}
                onMouseLeave={() => this.state.moduleMouseOver ? this.setState({ moduleMouseOver: null }) : null}
                className={style.blatt}
                style={{
                    right: `${right}%`, top: `${top}%`,
                    // ...(modulSelected === modulKey ? styleSelected : {})
                }}>
                {content}
            </div>
        );
    }

    renderModulInfo(): JSX.Element {
        const infoKey = `modul_${this.state.moduleMouseOver}`;
        return (
            <div key={infoKey}>
                <SimpleDialog
                    content={renderText(infoKey, this.props.data)}
                    hideCloseButton
                    // onClose={() => this.setState({ moduleMouseOver: null })}
                    setDialogPosition={(dw: number, dh: number, callback: (top: number, left: number) => void) => {
                        const mx = this.state.mousePosX;
                        const my = this.state.mousePosY;
                        const dt = Math.max(my - dh / 2, 0);
                        const dl = Math.max(mx - dw - 10, 0);
                        callback(dt, dl);
                    }}
                />
            </div>
        );
    }
}
